import { useSearchParams } from 'react-router';
import { useTranslation } from 'react-i18next';
import type { ICatalogItemDto } from '~/dtos/hub/hub.models.generated';
import {
  mapSearchParamsToSearchRequest,
  QUERY_SEARCH_PARAM_SEARCHTERM
} from '~/features/catalog/mappers/catalogSearchQueryMapper';

export function useCatalogSelectionInfo(catalogItems: ICatalogItemDto[]) {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();

  const urlSearchRequest = mapSearchParamsToSearchRequest(searchParams);

  const isTermSearch = searchParams.has(QUERY_SEARCH_PARAM_SEARCHTERM);
  let hwgId = urlSearchRequest?.hwgIds && urlSearchRequest?.hwgIds?.length > 0 ? urlSearchRequest.hwgIds[0] : undefined;
  let hagrId =
    urlSearchRequest?.hagrIds && urlSearchRequest?.hagrIds?.length > 0 ? urlSearchRequest.hagrIds[0] : undefined;
  const agrId =
    urlSearchRequest?.agrIds && urlSearchRequest?.agrIds?.length > 0 ? urlSearchRequest.agrIds[0] : undefined;

  let hwg = catalogItems?.find((x) => x.id == hwgId);
  let hagr = hwg?.child.find((x) => x.id == hagrId);

  if (hagrId && !hwgId) {
    hwg = catalogItems.find((x) => x.child.find((h) => h.id == hagrId));
    hwgId = hwg?.id;
    hagr = hwg?.child.find((x) => x.id == hagrId);
    hagrId = hagr?.id;
  } else if (agrId && (!hwgId || !hagrId)) {
    hwg = catalogItems.find((x) => x.child.find((h) => h.child.find((a) => a.id == agrId)));
    hwgId = hwg?.id;
    hagr = hwg?.child.find((x) => x.child.find((a) => a.id == agrId));
    hagrId = hagr?.id;
  }

  const agr = hagr?.child.find((x) => x.id == agrId);

  let title = t('Gesamtsortiment');

  if (agr) {
    title = agr.name;
  } else if (hagr) {
    title = hagr.name;
  } else if (hwg) {
    title = hwg.name;
  }

  return {
    title,
    isTermSearch,
    hwgId,
    hagrId,
    agrId,
    hwg,
    hagr,
    agr
  };
}
